import React from "react";
import LogsContainer from '../../Containers/LogsContainer';

const Logs = ()=>{
    return <LogsContainer></LogsContainer>
}

export default Logs;

